export default {
    name: "DigiByte",
    coin: "DGB",
    scheme: "SOLO",
    account: 'dgb1q3rtp74v0x5ey9s78afgkrm6szlcmfrkgpd4ld5',
    explorer_url: 'https://digiexplorer.info/',
    coingecko: 'https://www.coingecko.com/en/coins/digibyte',
    explorer: {
        address: "https://digiexplorer.info/address/",
        height: "https://digiexplorer.info/block/",
        hash: "https://digiexplorer.info/block/",
        tx: "https://digiexplorer.info/tx/",
    },
    ports: [
        {
            info: "LOW",
            host: "molepool.com",
            port: 7451,
            diff: 65536,
        },
        {
            info: "MID",
            host: "molepool.com",
            port: 7452,
            diff: 1048576,
        },
        {
            info: "HIGH",
            host: "molepool.com",
            port: 7453,
            diff: 10485760,
        }
    ]
};